import React, { useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, getBaseDir, float2moeda, userHasRole, getPatientTypeDataByRole } from '../../../utils.js';
import ReportFilter from '../../../components/report/ReportFilter.js';
import TableBuilder from '../../../table_builder.js';
const XLSX = require('xlsx');


const tableRef = new TableBuilder({
  table: '#table-manager-reports-list',
  tableBody: '.js-manager-reports-table',
  data: [],
  rowsPerPage: 25,
  filter: false,
  maxPages: 0,
  tableRowRenderer: function(rowData) {
    return mountTableRow(rowData, null);
  },
});

// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = $(this).text();
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-previous-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() - 1; //console.log('previous pageId', pageId);
  if (pageId <= 0)
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});
// Detecta alteração de página na tabela
$(document).on('click', `.js-pagination-next-page-${tableRef.getTableId()}`, function(e) {
  e.preventDefault();
  let pageId = tableRef.getCurrentPage() + 1; //console.log('next pageId', pageId);
  if (pageId > tableRef.getMaxPages())
      return;
  tableRef.setCurrentPage(pageId); //console.log('pageId', pageId);
});

const mountTableRow = (rowData, services, formData) => {
  services = localStorage.getItem('services') ? JSON.parse(localStorage.getItem('services')) : [];
  let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
    patient_id: rowData.CLIENTE_ID,
    branch: rowData.FILIAL
  });
  let valorServico = rowData.VALOR_UNITARIO;
  let doutorNome = $('.js-business-doctors-selector').first().find('option[value="' + rowData.STAFF_ID + '"]').text();
  let servicoNome = services.find((service) => service.ID == rowData.SERVICOS_ID);
  let reportType = formData.reportType;

  let isASell = rowData.VENDEU == 'S';
  let hasDoneContractUpload = rowData.UPLOAD_CONTRATO == 'S';
  let isASellAndPatientType = isASell && (rowData.TIPO_PACIENTE == 'PIT' || rowData.TIPO_PACIENTE == 'PIM');
  let contractUploadBgColor = isASell ? (hasDoneContractUpload == 'S' ? '' : 'background:yelow;') : '';

  return reportType === 'REPORTS_COMMISSION' ? (
    `<tr style="${contractUploadBgColor}">
      <td>${doutorNome}</td>
      <td><a href="${url}" target="new">${rowData.NOME_COMPLETO}</a></td>
      <td>${rowData.TIPO_PACIENTE}</td>
      <td>${servicoNome.DESCRICAO}</td>
      <td>C${rowData.CONTRATO_ID} ${rowData.PARCELA}</td>
      <td>${isASellAndPatientType ? '1' : ''}</td>
      <td>${(isASellAndPatientType) ? float2moeda(parseFloat(rowData.VALOR_CONTRATO).toFixed(2)) : ''}</td>
      <td>${(isASellAndPatientType) ? '0,00' : float2moeda(parseFloat(valorServico).toFixed(2))}</td>
      <td>${rowData.COMISSAO}%</td>
      <td>${float2moeda(parseFloat(rowData.VALOR_COMISSAO).toFixed(2))}</td>
      <td>${rowData.DATA_ATENDIMENTO_FORMATTED}</td>
      ${formData.branch == 14 ? `<td>${rowData['FOTO_PRESENCA_ID'] != null ? `<a href='${rowData['FOTO_PRESENCA_ID']}' target='new'>Possui facial</a>` : `Não possu facial`}</td>` : ''}
    </tr>`
  ) : reportType === 'REPORTS_COMMISSION_ATTENDANT' ? (
    `<tr style="${contractUploadBgColor}">
      <td>Atendido</td>
      <td>${doutorNome}</td>
      <td><a href="${url}" target="new">${rowData.NOME_COMPLETO}</a></td>
      <td>${rowData.TIPO_PACIENTE}</td>
      <td>${servicoNome.DESCRICAO}</td>
      <td>C${rowData.CONTRATO_ID} ${rowData.PARCELA}</td>
      <td>${isASell ? '1' : ''}</td>
      <td>${(isASell) ? float2moeda(parseFloat(rowData.VALOR_CONTRATO).toFixed(2)) : ''}</td>
      <td>${float2moeda(parseFloat(valorServico).toFixed(2))}</td>
      <td>${rowData.DATA_ATENDIMENTO_FORMATTED}</td>
      ${formData.branch == 14 ? `<td>${rowData['FOTO_PRESENCA_ID'] != null ? `<a href='${rowData['FOTO_PRESENCA_ID']}' target='new'>Possui facial</a>` : `Não possu facial`}</td>` : ''}
    </tr>`
  ) : '';
}

const ManagerReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [branches, setBusinessBranches] = useState([]);
  const [services, setServices] = useState([]);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [formData, setFormData] = useState({
    branch: '',
    branchName: '',
    startDate: '',
    endDate: '',
    reportType: '',
    recordsPerPage: 25,
    page: 1
  })
  const interval = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);

    apiCall({
        method: 'GET',
        endpoint: 'api/v1/employee/services',
        successCallback: function(res) {
          console.log('ManagerReports.js/services', 'onLoad', res);

          if (res.error) {
              
          } else {
            setServices(res.data);
            window.services = res.data;
            localStorage.setItem('services', JSON.stringify(res.data));
          }
        },
        errorCallback(err) {
            console.error('ERROR', 'ManagerReports.js/services', 'onLoad', err);
        }
    });
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);

    tableRef.setFetchTableData(fetchTableData);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (formData.reportType === '') {
      return window.toast({
        error: true,
        text: "Selecione o tipo de relatório!"
      });
    }

    if (formData.branch === '') {
      return window.toast({
        error: true,
        text: "Selecione a filial!"
      });
    }

    if (formData.startDate === '' || formData.endDate === '') {
      return window.toast({
        error: true,
        text: "Selecione o período!"
      });
    }

    window.localStorage.setItem('ManagerReportsFormData', JSON.stringify(formData));
    fetchTableData()
  }

  const fetchTableData = (pageId = false) => {
    let formData = JSON.parse(window.localStorage.getItem('ManagerReportsFormData'));
    if (pageId) {
      formData.page = pageId;
      setFormData(formData);
      window.localStorage.setItem('ManagerReportsFormData', JSON.stringify(formData));
    }
    
    setReportGenerated(false);
    setIsLoading(true);

    apiCall({
      endpoint: 'api/v1/reports/manager',
      method: 'GET',
      data: {
        ...formData
      },
      successCallback: (response) => {
        console.log('api/v1/reports/manager', 'onLoad', response);

        setReportGenerated(true);
        setIsLoading(false);

        formData.startDate = response.LABELS.startDate;
        formData.endDate = response.LABELS.endDate;
        setFormData(formData);
        window.localStorage.setItem('ManagerReportsFormData', JSON.stringify(formData));

        $('.js-manager-reports-table').html('');

        let 
          Find_PatientTypeData_PR = getPatientTypeDataByRole('PACIENTE_RETORNO'),
          Find_PatientTypeData_PN = getPatientTypeDataByRole('PACIENTE_NOVO');

        let totaisServicos = {
          PIT: 0,
          PIM: 0
        };
        totaisServicos[Find_PatientTypeData_PN['SIGLA']] = 0;
        totaisServicos[Find_PatientTypeData_PR['SIGLA']] = 0;

        let totaisContratos = {
          PIT: 0,
          PIM: 0
        };
        totaisContratos[Find_PatientTypeData_PN['SIGLA']] = 0;
        totaisContratos[Find_PatientTypeData_PR['SIGLA']] = 0;

        let totalComissao = {
          PIT: 0,
          PIM: 0
        };
        totalComissao[Find_PatientTypeData_PN['SIGLA']] = 0;
        totalComissao[Find_PatientTypeData_PR['SIGLA']] = 0;

        let totalSessoesVendidas = {
          PIT: 0,
          PIM: 0
        };

        setTimeout(function() {
          if (formData.reportType == 'REPORTS_COMMISSION_DIRECTOR') {
            let tableData = response.RESULTS;
            //console.log('tableData', tableData);

            let filial = $('.js-admin-agenda-filters').find('.js-business-branches-selector option:selected').text();

            for(let i = 0; i < Object.keys(tableData).length; ++i) {
              let rowData = Object.values(tableData)[i];
              let doutorNome = $('.js-business-doctors-selector').first().find('option[value="' + rowData.STAFF_ID + '"]').text();

              $('.js-manager-reports-table').append(`
                <tr>
                  <td>${filial}</td>
                  <td>${doutorNome}</td>
                  <td>${float2moeda(rowData.TOTAL_SERVICO)}</td>
                  <td>${float2moeda(rowData.TOTAL_COMISSAO)}</td>
                </tr>
              `);
            }

          } else {
            let tableData = response.RESULTS;
            
            let totalAtendimentos = {
              PIT: 0,
              PIM: 0
            };
            totalAtendimentos[Find_PatientTypeData_PN['SIGLA']] = 0;
            totalAtendimentos[Find_PatientTypeData_PR['SIGLA']] = 0;

            let totalFechamentos = {
              PIT: 0,
              PIM: 0
            }
            totalFechamentos[Find_PatientTypeData_PN['SIGLA']] = 0;
            totalFechamentos[Find_PatientTypeData_PR['SIGLA']] = 0;

            for (let i = 0; i < Object.keys(tableData).length; i++) {
              let rowData = Object.values(tableData)[i];
              let tipoPaciente = Object.keys(tableData)[i];

              if (!totaisServicos[tipoPaciente])
                totaisServicos[tipoPaciente] = 0;
              if (!totaisContratos[tipoPaciente])
                totaisContratos[tipoPaciente] = 0;
              if (!totalComissao[tipoPaciente])
                totalComissao[tipoPaciente] = 0;
              if (!totalFechamentos[tipoPaciente])
                totalFechamentos[tipoPaciente] = 0;

              totalAtendimentos[tipoPaciente] = rowData.length;

              for(let x = 0; x < rowData.length; x++) {
                let rowData2 = rowData[x];
                let VALOR_SERVICO = rowData2.VALOR_UNITARIO;
                if (tipoPaciente == Find_PatientTypeData_PN['SIGLA'] || tipoPaciente == Find_PatientTypeData_PR['SIGLA']) {
                  totaisServicos[tipoPaciente] = totaisServicos[tipoPaciente] + parseFloat(VALOR_SERVICO);
                  totalComissao[tipoPaciente] = totalComissao[tipoPaciente] + parseFloat(rowData2.VALOR_COMISSAO);
                }
                if (formData.reportType === 'REPORTS_COMMISSION_ATTENDANT' && rowData2.VENDEU == 'S' || rowData2.VENDEU == 'S' || (tipoPaciente == 'PIT' || tipoPaciente == 'PIM'))
                  totaisContratos[tipoPaciente] = totaisContratos[tipoPaciente] + parseFloat(rowData2.VALOR_CONTRATO);

                if (x === 0) {
                  $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .04);"><td colspan="${formData.branch == 14 ? '12' : '11'}" style="font-weight: bold;">TIPO => ${tipoPaciente}</td></tr>`);
                }

                if (formData.reportType === 'REPORTS_COMMISSION_ATTENDANT' && rowData2.VENDEU == 'S' || rowData2.VENDEU == 'S' && (rowData2.TIPO_PACIENTE == 'PIT' || rowData2.TIPO_PACIENTE == 'PIM')) {
                  totalFechamentos[tipoPaciente] = totalFechamentos[tipoPaciente] + 1;
                  totalSessoesVendidas[tipoPaciente] = totalSessoesVendidas[tipoPaciente] + rowData2.QT_SERVICO;
                }

                $('.js-manager-reports-table').append(mountTableRow(rowData2, services, formData));

                switch(formData.reportType) {
                  case 'REPORTS_COMMISSION': {
                    if (x == rowData.length - 1 && (tipoPaciente == Find_PatientTypeData_PN['SIGLA'] || tipoPaciente == Find_PatientTypeData_PR['SIGLA'])) {
                      $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .07);">
                        <td colspan="6" style="font-weight: bold;">Total</td>
                        <td></td>
                        <td>${float2moeda(parseFloat(totaisServicos[tipoPaciente]).toFixed(2))}</td>
                        <td></td>
                        <td>${float2moeda(parseFloat(totalComissao[tipoPaciente]).toFixed(2))}</td>
                        <td></td>
                        ${formData.branch == 14 ? `<td></td>` : ``}
                      </tr>`);
                    }
                    if (x == rowData.length - 1 && (tipoPaciente == 'PIT' || tipoPaciente == 'PIM')) {
                      $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .07);">
                        <td colspan="6" style="font-weight: bold;">Total</td>
                        <td>${parseFloat(totaisContratos[tipoPaciente]).toFixed(2)}</td>
                        <td>${parseFloat(totaisServicos[tipoPaciente]).toFixed(2)}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        ${formData.branch == 14 ? `<td></td>` : ``}
                      </tr>`);
                    }
                    break;
                  }
                  case 'REPORTS_COMMISSION_ATTENDANT': {
                    if (x == rowData.length - 1 && (tipoPaciente == Find_PatientTypeData_PN['SIGLA'] || tipoPaciente == Find_PatientTypeData_PR['SIGLA'])) {
                      $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .07);">
                        <td colspan="6" style="font-weight: bold;">Total</td>
                        <td>${totalFechamentos[tipoPaciente]}</td>
                        <td>${float2moeda(parseFloat(totaisContratos[tipoPaciente]).toFixed(2))}</td>
                        <td>${float2moeda(parseFloat(totaisServicos[tipoPaciente]).toFixed(2))}</td>
                        <td></td>
                        ${formData.branch == 14 ? `<td></td>` : ``}
                      </tr>`);
                    }
                    break;
                  }
                }

              }
            }

            var totalServicosPN = totaisServicos[Find_PatientTypeData_PN['SIGLA']] || 0;
            var totalServicosPR = totaisServicos[Find_PatientTypeData_PR['SIGLA']] || 0;
            var totalComissoesPN = totalComissao[Find_PatientTypeData_PN['SIGLA']] || 0;
            var totalComissoesPR = totalComissao[Find_PatientTypeData_PR['SIGLA']] || 0;
            var totalContratosPN = isNaN(totaisContratos[Find_PatientTypeData_PN['SIGLA']]) ? 0 : Number(parseFloat(totaisContratos[Find_PatientTypeData_PN['SIGLA']]).toFixed(2));
            var totalContratosPR = isNaN(totaisContratos[Find_PatientTypeData_PR['SIGLA']]) ? 0 : Number(parseFloat(totaisContratos[Find_PatientTypeData_PR['SIGLA']]).toFixed(2));
            var totalContratosPit = isNaN(totaisContratos['PIT']) ? 0 : Number(parseFloat(totaisContratos['PIT']).toFixed(2));
            var totalContratosPim = isNaN(totaisContratos['PIM']) ? 0 : Number(parseFloat(totaisContratos['PIM']).toFixed(2));
            const soma_total_contratos = float2moeda(parseFloat(totalContratosPN + totalContratosPR + totalContratosPit + totalContratosPim).toFixed(2));

            // soma total
            switch(formData.reportType) {
              case 'REPORTS_COMMISSION': {
                $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .2);">
                  <td colspan="6" style="font-weight: bold;">Total Geral</td>
                  <td>${soma_total_contratos}</td>
                  <td>${float2moeda(parseFloat(totalServicosPN + totalServicosPR).toFixed(2))}</td>
                  <td></td>
                  <td>${float2moeda(parseFloat(totalComissoesPN + totalComissoesPR).toFixed(2))}</td>
                  <td></td>
                  ${formData.branch == 14 ? `<td></td>` : ``}
                </tr>`);

                $(`.table-manager-reports-list-resume-content`).html(`
                  <tr>
                    <td></td>
                    <td>PIT</td>
                    <td>${totalAtendimentos['PIT']}</td>
                    <th>${totalFechamentos['PIT']}</th>
                    <th>${totalSessoesVendidas['PIT']}</th>
                    <th>${float2moeda(totalContratosPit)}</th>
                    <td>${float2moeda(totaisServicos['PIT'])}</td>
                    <td>${float2moeda(totalComissao['PIT'])}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>PN</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PN['SIGLA']]}</td>
                    <th>0</th>
                    <th>0</th>
                    <th>0.00</th>
                    <td>${float2moeda(totaisServicos[Find_PatientTypeData_PN['SIGLA']])}</td>
                    <td>${float2moeda(totalComissao[Find_PatientTypeData_PN['SIGLA']])}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>PR</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PR['SIGLA']]}</td>
                    <th>0</th>
                    <th>0</th>
                    <th>0.00</th>
                    <td>${float2moeda(totaisServicos[Find_PatientTypeData_PR['SIGLA']])}</td>
                    <td>${float2moeda(totalComissao[Find_PatientTypeData_PR['SIGLA']])}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>PIM</td>
                    <td>${totalAtendimentos['PIM']}</td>
                    <th>${totalFechamentos['PIM']}</th>
                    <th>${totalSessoesVendidas['PIM']}</th>
                    <th>${float2moeda(totalContratosPim)}</th>
                    <td>${float2moeda(totaisServicos['PIM'])}</td>
                    <td>${float2moeda(totalComissao['PIM'])}</td>
                  </tr>
                `);
      
                $('.table-manager-reports-list-resume-foot').html(`
                  <tr>
                    <td></td>
                    <td>Total</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PN['SIGLA']] + totalAtendimentos[Find_PatientTypeData_PR['SIGLA']] /*+ totalAtendimentos['PIT'] */ + totalAtendimentos['PIM']}</td>
                    <th>${float2moeda(totalFechamentos['PIT'] + totalFechamentos['PIM'])}</th>
                    <th>${float2moeda(totalSessoesVendidas['PIT'] + totalSessoesVendidas['PIM'])}</th>
                    <th>${float2moeda(soma_total_contratos)}</th>
                    <td>${float2moeda(totalServicosPN + totalServicosPR)}</td>
                    <td>${float2moeda(totalComissoesPN + totalComissoesPR)}</td>
                  </tr>
                `)
                break;
              }
              case 'REPORTS_COMMISSION_ATTENDANT': {
                totalContratosPN = Number(parseFloat(totalContratosPN).toFixed(2));
                totalContratosPR = Number(parseFloat(totalContratosPR).toFixed(2));

                /*console.log('soma_total_contratos', soma_total_contratos);
                console.log('totalContratosPN', typeof totalContratosPN);
                console.log('totalContratosPR', typeof totalContratosPR);
                console.log('totalContratosPN', totalContratosPN);
                console.log('totalContratosPR', totalContratosPR);
                console.log('totalcONTRATOSsOMA', totalContratosPN + totalContratosPR)*/

                $('.js-manager-reports-table').append(`<tr style="background-color:rgba(0, 0, 0, .2);">
                  <td colspan="5" style="font-weight: bold;">Total Geral</td>
                  <td></td>
                  <td></td>
                  <td>${parseFloat(totalContratosPN + totalContratosPR).toFixed(2)}</td>
                  <td>${parseFloat(totalServicosPN + totalServicosPR).toFixed(2)}</td>
                  <td></td>
                  ${formData.branch == 14 ? `<td></td>` : ``}
                </tr>`);

                $(`.table-manager-reports-list-resume-content`).html(`
                  <tr>
                    <td></td>
                    <td>PN</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PN['SIGLA']]}</td>
                    <th>${totalFechamentos[Find_PatientTypeData_PN['SIGLA']]}</th>
                    <th>${float2moeda(totalContratosPN)}</th>
                    <td>${float2moeda(totaisServicos[Find_PatientTypeData_PN['SIGLA']])}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td>PR</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PR['SIGLA']]}</td>
                    <th>${totalFechamentos[Find_PatientTypeData_PR['SIGLA']]}</th>
                    <th>${float2moeda(totalContratosPR)}</th>
                    <td>${float2moeda(totaisServicos[Find_PatientTypeData_PR['SIGLA']])}</td>
                  </tr>
                `);
      
                $('.table-manager-reports-list-resume-foot').html(`
                  <tr style="background-color:rgba(0, 0, 0, .2);">
                    <td></td>
                    <td>Total</td>
                    <td>${totalAtendimentos[Find_PatientTypeData_PN['SIGLA']] + totalAtendimentos[Find_PatientTypeData_PR['SIGLA']] /*+ totalAtendimentos['PIT'] PIT JA ESTA DENTRO DOS PNs*/ + totalAtendimentos['PIM'] }</td>
                    <th>${totalFechamentos['PIT'] + totalFechamentos['PIM'] + totalFechamentos[Find_PatientTypeData_PN['SIGLA']] + totalFechamentos[Find_PatientTypeData_PR['SIGLA']]}</th>
                    <th>${float2moeda(parseFloat(totalContratosPN + totalContratosPR).toFixed(2))}</th>
                    <td>${float2moeda(totalServicosPN + totalServicosPR)}</td>
                  </tr>
                `)
                break;
              }
            }

            if (formData.reportType === 'REPORTS_COMMISSION' || formData.reportType === 'REPORTS_COMMISSION_ATTENDANT') {
              let sales = response.LABELS.sales;
              let totalSales = 0;
              for (let i = 0; i < sales.length; i++) {
                console.log('sales', sales[i]);

                $('#table-manager-reports-list-sales tbody').append(`
                  <tr>
                    <td>${sales[i].NOME_COMPLETO}</td>
                    <td>Venda ${sales[i].ID}</td>
                    <td>${moment(sales[i].DATA_VENDA).format('DD/MM/YYYY')}</td>
                    <td>${float2moeda(sales[i].VALOR_TOTAL)}</td>
                  </tr>
                `);

                totalSales += parseFloat(sales[i].VALOR_TOTAL);
              }

              $('#table-manager-reports-list-sales tfoot').append(`
                <tr>
                  <td colspan="3">Total</td>
                  <td>${float2moeda(totalSales)}</td>
                </tr>
              `);
            }
            /*console.log('totaisServicos', totaisServicos);
            console.log('totaisContratos', totaisContratos);
            console.log('totalComissao', totalComissao);*/
          }
        }, 1500);

       

        //setTimeout(() => { tableRef.renderPage(tableRef.getCurrentPage(), false, response.RESULTS, false, response.LABELS.total) }, 1000);
      },
      errorCallback: (err) => {
        setIsLoading(false);
        console.error('error', err);
      }
    });
  }

  const exportToExcel = () => {
    let formData = JSON.parse(window.localStorage.getItem('ManagerReportsFormData'));
    formData.export = true;

    // Acquire Data (reference to the HTML table)
    var table_elt = document.getElementById("table-manager-reports-list");

    // Extract Data (create a workbook object from the table)
    var workbook = XLSX.utils.table_to_book(table_elt);

    // Process Data (add a new row)
    var ws = workbook.Sheets["Sheet1"];
    XLSX.utils.sheet_add_aoa(ws, [["Emitido em "+new Date().toISOString()]], {origin:-1});

    // Package and Release Data (`writeFile` tries to write and save an XLSB file)
    XLSX.writeFile(workbook, 'relatorio_gerencia_comissoes_'+window.getSaoPauloDateTime()+'.xlsx');
  }

  const exportJsPdf = () => {
    const { jsPDF } = window.jspdf;
    // Create a new jsPDF instance with landscape orientation
    const doc = new jsPDF('landscape');

    // Base64 encoded image string (you can convert your image to Base64)
    const imgData = 'data:image/png;base64,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'; // Replace this with your Base64 image string

    // Convert Base64 to image
    const logo = new Image();
    logo.src = imgData;
    logo.onload = function() {
        const logoWidth = 25; // Adjust logo width as needed
        const logoHeight = (logo.height * logoWidth) / logo.width;

        // Add logo to PDF
        doc.addImage(logo, 'PNG', 5, 5, logoWidth, logoHeight);

        // Add title
        doc.setFontSize(14);
        // Get the width of the PDF page
        const pageWidth = doc.internal.pageSize.getWidth();

        var reportType = "";
        switch(formData.reportType) {
          case 'REPORTS_COMMISSION': {
            reportType = "gerente";
            break;
          }
          case 'REPORTS_COMMISSION_ATTENDANT': {
            reportType = "atendente";
            break;
          }
          case 'REPORTS_COMMISSION_DIRECTOR': {
            reportType = "diretoria";
            break;
          }
        }

        var titleText = "Relatório Gerencial de Comissões - "+reportType;
        // Get the width of the text to center it
        var textWidth = doc.getTextWidth(titleText);
        // Calculate the X coordinate to center the text
        var textX = (pageWidth - textWidth) / 2;

        // Add title at the top and centered
        doc.text(titleText, textX, 10);

        titleText = `Relatório gerado em ${window.getSaoPauloDateTime()}`;
        // Get the width of the text to center it
        textWidth = doc.getTextWidth(titleText);
        // Calculate the X coordinate to center the text
        textX = (pageWidth - textWidth) / 2;    
        // Add title at the top and centered
        doc.text(titleText, textX, 15);

        titleText = `Período: ${moment(formData.startDate).format('DD/MM/YYYY')} ${formData.endDate !== '' ? `até ${moment(formData.endDate).format('DD/MM/YYYY')}` : ''}`;
        // Get the width of the text to center it
        textWidth = doc.getTextWidth(titleText);
        // Calculate the X coordinate to center the text
        textX = (pageWidth - textWidth) / 2;
        // Add title at the top and centered
        doc.text(titleText, textX, 20);

        let columnStyles = {};
        if (formData.reportType === 'REPORTS_COMMISSION') {
          columnStyles = {
            0: { cellWidth: 20 }, // Doutor
            1: { cellWidth: 80 }, // Cliente
            2: { cellWidth: 15 },  // Tipo
            3: { cellWidth: 50 },  // Serviço
            4: { cellWidth: 25 },  // Contrato + parcela
            5: { cellWidth: 8 },  // Fechou
            6: { cellWidth: 20 },  // Vlr Contrato
            7: { cellWidth: 15 },  // Valor
            8: { cellWidth: 10 },  // Comissao %
            9: { cellWidth: 20 },  // Vlr. Comissao
            10: { cellWidth: 25 },  // Atendimento
            11: { cellWidth: 25 }  // Facial
          }
        }
        if (formData.reportType === 'REPORTS_COMMISSION_ATTENDANT') {
          columnStyles = {
            0: { cellWidth: 20 }, // Categoria
            1: { cellWidth: 20 }, // Doutor
            2: { cellWidth: 80 }, // Cliente
            3: { cellWidth: 15 },  // Tipo
            4: { cellWidth: 50 },  // Serviço
            5: { cellWidth: 25 },  // Contrato + parcela
            6: { cellWidth: 8 },  // Fechou
            7: { cellWidth: 20 },  // Vlr Contrato
            8: { cellWidth: 15 },  // Valor
            9: { cellWidth: 25 },  // Atendimento
            10: { cellWidth: 25 }  // Facial
          }
        }

        // Extract table and add to PDF
        doc.autoTable({
            html: '#table-manager-reports-list',
            startY: 25,
            theme: 'grid',
            styles: { 
              fontSize: 9, // Decrease font size to fit more content
              cellPadding: 1
            },
            headStyles: {
              fillColor: [255, 0, 0]
            },
            alternateRowStyles: {
              fillColor: [240, 240, 240]
            },
            columnStyles: columnStyles,
            margin: { top: 1, right: 1, bottom: 1, left: 1 },
            scale: 0.8 // Scale content to fit the page
        });

        // extract resume table 
        doc.autoTable({
          html: '#table-manager-reports-list-resume',
          startY: doc.autoTable.previous.finalY + 10,
          theme: 'grid',
          styles: { 
            fontSize: 9, // Decrease font size to fit more content
            cellPadding: 1
          },
          headStyles: {
            fillColor: [255, 0, 0]
          },
          alternateRowStyles: {
            fillColor: [240, 240, 240]
          },
        });

        if (formData.reportType === 'REPORTS_COMMISSION' || formData.reportType === 'REPORTS_COMMISSION_ATTENDANT') {
          // extract sales table
          doc.autoTable({
            html: '#table-manager-reports-list-sales',
            startY: doc.autoTable.previous.finalY + 10,
            theme: 'grid',
            styles: { 
              fontSize: 9, // Decrease font size to fit more content
              cellPadding: 1
            },
            headStyles: {
              fillColor: [255, 0, 0]
            },
          });
        }

        // Add a title to the PDF
        //doc.text("My Custom Table in Landscape", 14, 15);

        // Save the PDF
        doc.save('relatorio_gerencia_comissoes_'+window.getSaoPauloDateTime()+'_'+reportType+'.pdf');
    }
  }

  return (
    <>
     <div className="col-12 p-2">
      <div class="d-flex justify-content-center">
        <form className="row w-50" onSubmit={(e) => handleSubmit(e)}>
          <ReportFilter setFormData={setFormData} hasDoctor={true} setAsOpen={true} strings={
            {
              START_DATE_STRING: 'Data Atendimento Inicial',
              END_DATE_STRING: 'Data Atendimento Inicial',
            }
          } />
          <div className="form-group mb-3">
            <label>Relatório:</label>
            <select className="form-control form-control" onChange={(e) => {
              setFormData((prev) => {
                return {
                  ...prev,
                  reportType: e.target.value
                }
              });
              setReportGenerated(false);
            }}>
              <option selected default value="">-- Selecione --</option>
              {/*<option value="AVALIATION_EXAM">Quem agendou avaliação</option>*/}
              {(userHasRole('ADMIN') || userHasRole('MANAGER') || userHasRole('ADMIN_ASSISTANT') || userHasRole('COMMERCIAL_ASSISTANT')) && (
                <option value="REPORTS_COMMISSION_ATTENDANT">Relatório de Comissão (Atendente)</option>
              )}
              {(userHasRole('ADMIN') || userHasRole('MANAGER') || userHasRole('ADMIN_ASSISTANT')  || userHasRole('DOCTOR') || userHasRole('DOCTOR_2')) && (
                <option value="REPORTS_COMMISSION">Relatório de Comissão (Gerência)</option>
              )}
              {(userHasRole('ADMIN') || userHasRole('MANAGER') || userHasRole('ADMIN_ASSISTANT')) && (
                <option value="REPORTS_COMMISSION_DIRECTOR">Relatório de Comissão (Diretoria)</option>
              )}
              {/*<option value="PERCENTAGE_ACTIVE_TREATMENT_PLAN_">Quantos % terminou tratamento inicial</option>*/}
            </select>
          </div>
          <div className="form-group mb-3">
            <button type='submit' className="btn btn-primary">Gerar Relatório</button>
            {formData.reportType && reportGenerated && (
              <>
                <button type="button" className='btn btn-secondary ml-2' onClick={() => exportToExcel()}>Exportar para Excel</button>
                <button type="button" className='btn btn-secondary ml-2' onClick={() => exportJsPdf()}>Exportar para PDF</button>
              </>
            )}
          </div>
        </form>
      </div> 
      {isLoading && 'Carregando, por favor, aguarde...'}
      {formData.reportType && reportGenerated && (
        <>
          Relatório da Gerência {formData.reportType && `(${type[formData.reportType]})`}<br />Período: {formData.startDate} {formData.endDate !== '' && `até ${formData.endDate}`}
          <table className="table table-bordered" id="table-manager-reports-list">
            <thead>
              <tr>
                {formData.reportType === 'REPORTS_COMMISSION' && (
                  <>
                    <th>Doutor(a)</th>
                    <th>Cliente</th>
                    <th>Tipo</th>
                    <th>Serviço</th>
                    <th>Contrato/Sessão</th>
                    <th>Fechou</th>
                    <th>Vlr. Contrato</th>
                    <th>Valor</th>
                    <th>Comissao %</th>
                    <th>Vlr. Comissão</th>
                    <th>Atendimento</th>
                    {formData.branch == 14 ? (<th>Facial</th>) : ``}
                  </>
                )}
                {formData.reportType === 'REPORTS_COMMISSION_ATTENDANT' && (
                  <>
                    <th>Categoria</th>
                    <th>Doutor(a)</th>
                    <th>Cliente</th>
                    <th>Tipo</th>
                    <th>Serviço</th>
                    <th>Contrato/Sessão</th>
                    <th>Fechou</th>
                    <th>Vlr. Contrato</th>
                    <th>Valor</th>
                    <th>Atendimento</th>
                    {formData.branch == 14 ? (<th>Facial</th>) : ``}
                  </>
                )}
                {formData.reportType === 'REPORTS_COMMISSION_DIRECTOR' && (
                  <>
                    <th>Filial</th>
                    <th>Quiro/Masso</th>
                    <th>Valor</th>
                    <th>Comissão</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody className="js-manager-reports-table"></tbody>
          </table>

          <table class="table table-bordered" id="table-manager-reports-list-resume">
            <caption>Resumo de comissões</caption>
            <thead>
              <tr>
                {formData.reportType === 'REPORTS_COMMISSION' && (
                  <>
                  <th></th>
                  <th>Tipo Paciente</th>
                  <th>Qtd.</th>
                  <th>Fechou</th>
                  <th>Sessões Vendidas</th>
                  <th>Contrato (soma)</th>
                  <th>Valor</th>
                  <th>Valor comissão</th>
                  </>
                )}
                {formData.reportType === 'REPORTS_COMMISSION_ATTENDANT' && (
                  <>
                  <th></th>
                  <th>Categoria</th>
                  <th>Qtd.</th>
                  <th>Sessões Vendidas</th>
                  <th>Contrato (soma)</th>
                  <th>Valor</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody class="table-manager-reports-list-resume-content"></tbody>
            <tfoot class="table-manager-reports-list-resume-foot"></tfoot>
          </table>

          {(formData.reportType === 'REPORTS_COMMISSION' || formData.reportType === 'REPORTS_COMMISSION_ATTENDANT') && (
            <table className="table table-bordered" id="table-manager-reports-list-sales">
              <caption>Vendas</caption>
              <thead>
                  <tr>
                      <th>Cliente</th>
                      <th>Venda</th>
                      <th>Data</th>
                      <th>Valor</th>
                  </tr>
              </thead>
              <tbody className="table-manager-reports-list-sales-content"></tbody>
              <tfoot className="table-manager-reports-list-resume-sels"></tfoot>
            </table>
          )}
        </>
      )}
      </div>
    </>
  );
}

try {
  if (document.getElementById('js-manager-reports-content')) {
    const container = document.getElementById('js-manager-reports-content');
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<ManagerReports />);
  }
} catch(err) {
  console.error('ManagerReports error', err);
}

const type = {
  REPORTS_COMMISSION: "Relatório de Comissão (Gerência)",
  REPORTS_COMMISSION_ATTENDANT: "Relatório de Comissão (Atendente)",
  REPORTS_COMMISSION_DIRECTOR: "Relatório de Comissão (Diretoria)"
}